import React, { useState, useContext } from 'react';
import { Link, graphql } from 'gatsby';
import styled from 'styled-components';
import Layout from '~/components/Layout';
import Seo from '~/components/SEO';
import GetStartedForm from '~/components/Forms/GetStarted/GetStartedForm';
import logoBlack from '~/images/logo.svg';
import useStoryblok from '~/utils/storyblok-service';
import Image from '~/components/Dynamic/Image';
import TextCard from '~/components/Dynamic/TextCard';
import blackArrow from '~/icons/black-arrow.svg';
import deliveroo from '~/icons/deliveroo.svg';
import oyo from '~/icons/oyo.svg';
import campari from '~/icons/campari.svg';
import sothebys from '~/icons/sothebys.svg';
import renderLink from '~/utils/render-link';

const GetStartedContainer = styled.div`
  .lhs {
    position: relative;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      right: 100%;
      width: 1000px;
      background-color: inherit;
    }
  }
`;

export default function GetStarted({ data, location, pageContext }) {
  const story = useStoryblok(data.storyblokEntry, location);
  const content = story.content;
  const [isSubmitted, setIsSubmitted] = useState(false);

  // console.log(content)
  return (
    <Layout hideHeader hideFooter locale={pageContext.locale}>
      <Seo {...content.seo} lang={story.lang} pageContext={pageContext} />

      <GetStartedContainer className={`page--get-started min-h-screen lg:min-h-0 flex flex-col ${isSubmitted ? 'is-sent' : ''}`}>
        <div className="absolute top-0 left-0 bottom-0 w-5/12  max-w-md  pointer-events-none hidden lg:block">
          <div className="absolute top-0 left-0 bottom-0 -right-5 bg-beige"></div>
        </div>
        <div className="flex flex-col flex-auto px-5 pr-0">
          <div className="flex flex-col flex-auto lg:flex-row">
            <div className="flex flex-col flex-auto order-1 lhs bg-beige lg:w-5/12 lg:order-none lg:max-w-md">
              <div className="top-0 flex flex-col flex-auto lhs md:sticky">
                <div className="flex flex-col items-center justify-center h-full p-8 pt-20 pl-0 md:pt-8">
                  <Link
                    to={`/${pageContext?.lang !== 'default' ? pageContext.lang : ''}`}
                    className="justify-center hidden w-full mb-20 md:inline-flex"
                  >
                    <img src={logoBlack} alt="" />
                  </Link>
                  {content?.leftHandSide && (
                    <>
                      <div className="max-w-[23rem] mx-auto text-center flex-auto">
                        <h3 className="text-h4 max-w-[18rem] mx-auto mb-3">{content?.leftHandSide[0]?.heading}</h3>
                        <p>{content?.leftHandSide[0]?.content}</p>
                      </div>
                      <div className="w-full">
                        <div className="py-12 -mx-8">
                          <Image blok={content?.leftHandSide[0]?.icon} imageClassName="w-full" />
                        </div>
                      </div>

                      <div className="mb-12 overflow-hidden logos">
                        <div className="font-bold text-center uppercase font-heading text-13px">
                          {content?.leftHandSide[0]?.subHeading}
                        </div>
                        <div className="flex justify-between mt-8 space-x-8 md:mt-4">
                          <div className="max-h-5">
                            <img src={deliveroo} className="h-full mx-auto" />
                          </div>
                          <div className="max-h-5">
                            <img src={oyo} className="h-full mx-auto" />
                          </div>
                          <div className="max-h-5">
                            <img src={campari} className="h-full mx-auto" />
                          </div>
                          <div className="max-h-5">
                            <img src={sothebys} className="h-full mx-auto" />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="justify-center pr-5 bg-white lg:pr-0 lg:w-8/12 md:flex">
              <div className="flex flex-col flex-auto mt-8 mb-16 md:my-0 md:p-12 md:mt-0 lg:-mt-4 lg:p-16">
                {!isSubmitted ? (
                  <>
                    <Link to={`/${pageContext?.lang !== 'default' ? pageContext.lang : ''}`} className="inline-flex justify-between w-full mb-12">
                      <img src={logoBlack} alt="" className="md:hidden" />
                      <div className="flex items-center">
                        <img src={blackArrow} alt="" className="mr-2 transform -rotate-180" /> {content?.backButton}
                      </div>
                    </Link>
                    <section className="flex-auto max-w-2xl md:mt-10 md:mx-auto">
                      <div>{content.rightHandSide && <TextCard blok={content.rightHandSide[0]} />}</div>
                      <GetStartedForm isSubmitted={isSubmitted} setIsSubmitted={setIsSubmitted} />
                    </section>
                  </>
                ) : (
                  <div className="flex flex-col items-center justify-center flex-auto text-center">
                    <div className="max-w-lg mx-auto">
                      {content.confirmation && (
                        <TextCard
                          blok={{
                            ...content.confirmation[0],
                            iconClass: 'max-w-[40px]',
                          }}
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </GetStartedContainer>
    </Layout>
  );
}

export const query = graphql`
  query getStartedQuery($id: String!) {
    storyblokEntry(id: { eq: $id }) {
      id
      name
      content
      lang
      slug
      uuid
      full_slug
    }
  }
`;
